import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { BlogSearch } from 'components/blog/blog-search';
import { BlogSubnav } from 'components/blog/blog-subnav';

const BlogToolbar = () => {
	// Render
	return (
		<div>
			<div className='mx-auto max-w-6xl px-5 sm:px-8'>
				<div className='flex-column gap-4 py-4 lg:flex-between'>
					<BlogSubnav />
					<div className='flex-start w-full shrink-0 gap-2 lg:w-auto'>
						<div className='min-w-0 grow sm:min-w-72 lg:w-80'>
							<BlogSearch />
						</div>
						<Link variant='outline' size='icon' aria-label='RSS feed' href='/atom' target='_blank'>
							<Icon data-icon='inline-start' type='far' icon='rss' aria-hidden />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};
export { BlogToolbar };
